var _path, _mask, _rect, _mask2, _rect2, _mask3, _rect3, _mask4, _rect4, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolygonselect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.65845 5.95154C3.65845 6.2034 3.65845 14.7667 3.65845 19.0483",
    stroke: "black"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_206_983",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.34961,
    y: 18.8002,
    width: 2.8,
    height: 2.8,
    rx: 0.648275
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.34961,
    y: 18.8002,
    width: 2.8,
    height: 2.8,
    rx: 0.648275,
    stroke: "black",
    strokeWidth: 2,
    mask: "url(#path-2-inside-1_206_983)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-2_206_983",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.34961,
    y: 3.3999,
    width: 2.8,
    height: 2.8,
    rx: 0.648275
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.34961,
    y: 3.3999,
    width: 2.8,
    height: 2.8,
    rx: 0.648275,
    stroke: "black",
    strokeWidth: 2,
    mask: "url(#path-3-inside-2_206_983)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-3_206_983",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.8501,
    y: 16.0005,
    width: 2.8,
    height: 2.8,
    rx: 0.648275
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 19.8501,
    y: 16.0005,
    width: 2.8,
    height: 2.8,
    rx: 0.648275,
    stroke: "black",
    strokeWidth: 2,
    mask: "url(#path-4-inside-3_206_983)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-4_206_983",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.8501,
    y: 6.19983,
    width: 2.8,
    height: 2.8,
    rx: 0.648275
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 19.8501,
    y: 6.19983,
    width: 2.8,
    height: 2.8,
    rx: 0.648275,
    stroke: "black",
    strokeWidth: 2,
    mask: "url(#path-5-inside-4_206_983)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.96924 4.64209L20.3772 7.17695M21.3402 8.19089V16.5559M4.96924 20.3582L20.3772 17.8234",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygonselect);
export default __webpack_public_path__ + "static/media/polygonselect.b982f7db9e4ed02cd6696f2397f7f9c3.svg";
export { ForwardRef as ReactComponent };